import { render, staticRenderFns } from "./BsSlider.vue?vue&type=template&id=0d979ccd"
import script from "./BsSlider.vue?vue&type=script&lang=js"
export * from "./BsSlider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports